// MPH-785: the backend pricing expires ~30 minutes after it is minted (see the refreshInterval note
// in PricingProvider), and any request that then uses the expired pricingId fails with
// not-found-style errors. These constants currently gate only the checkout path (cart creation in
// useCartCreation plus the review-entry/visibility refreshes); the rooms and transport fetches key
// on the bare pricingId — no age check — and get fresh data indirectly, when a gate-triggered
// refresh mints a new pricingId and re-keys them. `time` is the client timestamp stamped on the
// pricing response by useCreateAsyncPricing.

// Age past which a pricing must not feed any new request. 25 minutes leaves a 5-minute safety
// margin over the backend TTL for clock/transport skew and for the requests it still has to serve.
export const PRICING_MAX_AGE_MS = 1000 * 60 * 25;

// Minimum age at which a cart-creation not-found error is attributed to pricing staleness and
// recovered by re-pricing (see useCartCreation). Below it the pricing is fresh enough that the
// error must be genuine unavailability. A recovery attempt always runs with a just-minted pricing
// (age ≈ 0 < this bar), so recovery is self-limiting by construction: it can never loop.
export const STALE_RECOVERY_MIN_AGE_MS = 1000 * 60 * 2;

export function pricingAgeMs(time: number | undefined): number {
  return time === undefined ? 0 : Date.now() - time;
}

export function isPricingStale(time: number | undefined): boolean {
  return pricingAgeMs(time) > PRICING_MAX_AGE_MS;
}
